module.exports = __webpack_public_path__ + "static/media/backgroundright.c08e78ed.svg";